<div>
  <h1 class="mdc-typography--headline1">Headline 1</h1>
  <h2 class="mdc-typography--headline2">Headline 2</h2>
  <h3 class="mdc-typography--headline3">Headline 3</h3>
  <h4 class="mdc-typography--headline4">Headline 4</h4>
  <h5 class="mdc-typography--headline5">Headline 5</h5>
  <h6 class="mdc-typography--headline6">Headline 6</h6>
  <h6 class="mdc-typography--subtitle1">Subtitle 1</h6>
  <h6 class="mdc-typography--subtitle2">Subtitle 2</h6>
  <p class="mdc-typography--body1">
    Body 1. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos
    blanditiis tenetur unde suscipit, quam beatae rerum inventore consectetur,
    neque doloribus, cupiditate numquam dignissimos laborum fugiat deleniti? Eum
    quasi quidem quibusdam.
  </p>
  <p class="mdc-typography--body2">
    Body 2. Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate
    aliquid ad quas sunt voluptatum officia dolorum cumque, possimus nihil
    molestias sapiente necessitatibus dolor saepe inventore, soluta id
    accusantium voluptas beatae.
  </p>
  <div><span class="mdc-typography--button">Button text</span></div>
  <div><span class="mdc-typography--caption">Caption text</span></div>
  <div><span class="mdc-typography--overline">Overline text</span></div>
</div>
<div class="flex-container">
  <!-- <app-messages></app-messages> -->
  <div class="green-zebra left">
    <iframe
      frameborder="none"
      width="100%"
      height="1532px"
      src="https://tcc-web-99a64.firebaseapp.com/"
    ></iframe>

    <markdown [src]="'https://tcc-web-99a64.firebaseapp.com'"></markdown>

    <!-- <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLScno2gVoJ_vDDVlqgXzpB0IZuIKbI4Ia5rNTztbLMCYc9Rexw/viewform?embedded=true"
            width="100%"
            height="760"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
            >Загрузка...</iframe
        >

        <iframe
            src="https://calendar.google.com/calendar/embed?showTitle=0&amp;showNav=0&amp;showDate=0&amp;showPrint=0&amp;showTabs=0&amp;showCalendars=0&amp;showTz=0&amp;mode=AGENDA&amp;height=600&amp;wkst=1&amp;bgcolor=%23FFFFFF&amp;src=je8ni3dai1gnrsl2hlo6lbkb4o%40group.calendar.google.com&amp;color=%232F6309&amp;ctz=Europe%2FMoscow"
            style="border-width:0"
            width="100%"
            height="320"
            frameborder="0"
            scrolling="no"
        ></iframe> -->

    <h3 class="mat-h3">Basic Buttons</h3>
    <div class="example-button-row">
      <button mat-button>Basic</button>
      <button mat-button color="primary">Primary</button>
      <button mat-button color="accent">Accent</button>
      <button mat-button color="warn">Warn</button>
      <button mat-button disabled>Disabled</button>
      <a mat-button routerLink=".">Link</a>
    </div>

    <h3>Raised Buttons</h3>
    <div class="example-button-row">
      <button mat-raised-button>Basic</button>
      <button mat-raised-button color="primary">Primary</button>
      <button mat-raised-button color="accent">Accent</button>
      <button mat-raised-button color="warn">Warn</button>
      <button mat-raised-button disabled>Disabled</button>
      <a mat-raised-button routerLink=".">Link</a>
    </div>

    <h3>Stroked Buttons</h3>
    <div class="example-button-row">
      <button mat-stroked-button>Basic</button>
      <button mat-stroked-button color="primary">Primary</button>
      <button mat-stroked-button color="accent">Accent</button>
      <button mat-stroked-button color="warn">Warn</button>
      <button mat-stroked-button disabled>Disabled</button>
      <a mat-stroked-button routerLink=".">Link</a>
    </div>

    <h3>Flat Buttons</h3>
    <div class="example-button-row">
      <button mat-flat-button>Basic</button>
      <button mat-flat-button color="primary">Primary</button>
      <button mat-flat-button color="accent">Accent</button>
      <button mat-flat-button color="warn">Warn</button>
      <button mat-flat-button disabled>Disabled</button>
      <a mat-flat-button routerLink=".">Link</a>
    </div>

    <h3>Icon Buttons</h3>
    <div class="example-button-row">
      <button mat-icon-button>
        <mat-icon aria-label="Example icon-button with a heart icon"
          >done</mat-icon
        >
      </button>
      <button mat-icon-button color="primary">
        <mat-icon aria-label="Example icon-button with a heart icon"
          >done</mat-icon
        >
      </button>
      <button mat-icon-button color="accent">
        <mat-icon aria-label="Example icon-button with a heart icon"
          >favorite</mat-icon
        >
      </button>
      <button mat-icon-button color="warn">
        <mat-icon aria-label="Example icon-button with a heart icon"
          >favorite</mat-icon
        >
      </button>
      <button mat-icon-button disabled>
        <mat-icon aria-label="Example icon-button with a heart icon"
          >favorite</mat-icon
        >
      </button>
    </div>

    <h3>Fab Buttons</h3>
    <div class="example-button-row">
      <button mat-fab>Basic</button>
      <button mat-fab color="primary">Primary</button>
      <button mat-fab color="accent">Accent</button>
      <button mat-fab color="warn">Warn</button>
      <button mat-fab disabled>Disabled</button>
      <button mat-fab>
        <mat-icon class="md-36" inline aria-label="Home button">
          home
        </mat-icon>
      </button>
      <button mat-fab>
        <mat-icon class="md-48" inline aria-label="Up button">
          expand_less
        </mat-icon>
      </button>
      <a mat-fab routerLink=".">Link</a>
    </div>

    <h3>Mini Fab Buttons</h3>
    <div class="example-button-row">
      <button mat-mini-fab>Basic</button>
      <button mat-mini-fab color="primary">Primary</button>
      <button mat-mini-fab color="accent">Accent</button>
      <button mat-mini-fab color="warn">Warn</button>
      <button mat-mini-fab disabled>Disabled</button>
      <button mat-mini-fab>
        <mat-icon class="md-36" inline aria-label="Home button">home</mat-icon>
      </button>
      <a mat-mini-fab routerLink=".">Link</a>
    </div>
    <!-- <div style="position: relative;">
            <iframe
                frameborder="none"
                width="100%"
                height="600px"
                src="https://docs.google.com/document/d/e/2PACX-1vSVGb84ze6XatlXMCG6NasOLW-dMlRogttPzgYn9SgSigZzDOrzXW9eSGAiSenAwlHoGPHsxM3Zu4n6/pub?embedded=true"
            ></iframe>

            <a
                mat-icon-button
                style="position: absolute; right:-40; top:0;"
                href="https://docs.google.com/document/d/1A7g_ElBCDCp_317qmLQgLk7Z-ecwbPTkKpa5wygGJQo/edit?usp=sharing"
                target="_blank"
            >
                <mat-icon>open_in_new</mat-icon>
            </a>
        </div> -->

    <div class="reading">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent nec
      venenatis eros, at laoreet nunc. Maecenas ex dolor, pharetra vitae est
      quis, dictum sagittis nibh. Nulla risus nisi, interdum vitae dictum eu,
      rhoncus pharetra neque. Aenean augue purus, accumsan sit amet risus quis,
      tempus molestie odio. Aliquam scelerisque pharetra consectetur. Interdum
      et malesuada fames ac ante ipsum primis in faucibus. Ut vel ante mi. In
      auctor, diam ut tincidunt suscipit, nibh nibh cursus odio, luctus dictum
      mauris mauris ac urna. Phasellus rutrum semper aliquet. Donec eget nisl
      ex. Praesent aliquet lacus nec risus dignissim cursus. Morbi vestibulum
      nisi at massa accumsan malesuada. Maecenas ac augue id turpis molestie
      egestas eget vel mi. Suspendisse vitae odio eget purus venenatis blandit.
      Nunc in leo in elit laoreet euismod at tristique sem. Integer sed erat eu
      odio mattis ullamcorper. Aenean suscipit lacus sed ipsum dictum porttitor.
      Morbi dignissim leo vitae suscipit consectetur. Aliquam varius non tellus
      ultrices finibus. Quisque semper turpis ac metus sagittis, nec blandit
      neque viverra. Duis tempus orci non neque tincidunt, id facilisis arcu
      iaculis. Ut aliquet congue pulvinar. Proin ullamcorper, arcu in iaculis
      tincidunt, ex erat porttitor enim, sit amet consectetur magna nulla non
      nunc. Proin sollicitudin vulputate justo, aliquet gravida mi tempus quis.
      Ut bibendum dictum lorem laoreet elementum. Duis sed euismod sem, aliquam
      faucibus nibh. Fusce nec turpis facilisis, porta dui sed, sagittis mi. Nam
      mattis in ex in hendrerit. Ut eget congue ligula. Donec bibendum eu tellus
      sed vestibulum. Pellentesque efficitur dignissim vestibulum. Sed non est
      semper, viverra sem vitae, dignissim purus. Suspendisse quis mollis dolor.
      Vivamus quis ligula magna. Mauris fermentum velit leo, a maximus risus
      condimentum vitae. Orci varius natoque penatibus et magnis dis parturient
      montes, nascetur ridiculus mus. Duis id ultricies orci. Ut feugiat justo
      eu turpis sagittis, nec aliquet mauris vulputate. Proin sit amet neque
      elementum urna fringilla sollicitudin a eu dui. Pellentesque habitant
      morbi tristique senectus et netus et malesuada fames ac turpis egestas.
      Duis tristique ante et nisi suscipit mattis sit amet quis massa. Nullam
      ullamcorper risus vitae vehicula pharetra. Sed sed aliquam urna.
      Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere
      cubilia Curae; Cras non ligula ut velit lacinia tincidunt. Maecenas dolor
      orci, volutpat eget nisl a, maximus porttitor justo. Aliquam sit amet
      cursus erat. Vestibulum urna velit, scelerisque eu malesuada at, aliquet
      sit amet tellus. Proin maximus nec ipsum eget fermentum. Fusce non
      vulputate arcu. Proin dictum euismod efficitur. Cras vulputate arcu
      tellus, eu gravida lectus suscipit non. Nulla facilisi. Fusce metus dui,
      pharetra eget suscipit vel, pharetra non libero. Sed sed risus leo. Nullam
      ultrices velit vitae nisi faucibus placerat. Vestibulum molestie efficitur
      diam id elementum. Vivamus laoreet leo in mi malesuada, at maximus erat
      faucibus. Donec at blandit orci. Phasellus condimentum, nunc a commodo
      pellentesque, urna turpis dictum nisl, a maximus justo magna vel mi.
      Aenean ut bibendum diam, iaculis egestas orci. Fusce egestas mauris at
      diam varius pellentesque.
    </div>
  </div>
  <div class="red-zebra right">
    <div class="green-zebra right-inner">right</div>
    right
  </div>
</div>
